export default {
    inject: ['user'],
    computed: {
        indexById () {
            const index = {}
            this.index.forEach((i) => {
                index[i.id] = i
            })
            return index
        },
        filteredHighlights () {
            if (!this.selectedFilters.length) {
                return this.orderedHighlights
            }
            return this.orderedHighlights.filter(h => (!this.selectedFilters.includes('note') && this.selectedFilters.includes(h.color_class)) ||
                (this.selectedFilters.length === 1 && this.selectedFilters.includes('note') && h.note && h.note.length) ||
                (this.selectedFilters.includes(h.color_class) && this.selectedFilters.includes('note') && h.note && h.note.length)
            )
        },
        orderedHighlights () {
            return this.allHighlights.filter(h => h.user && this.user && h.user.id === this.user.id).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        }
    },
    data () {
        return {
            filters: {
                redHighlight: {
                    class: 'bg-red-400',
                    selectedClass: 'bg-red-100'
                },
                yellowHighlight: {
                    class: 'bg-yellow-400',
                    selectedClass: 'bg-yellow-100'
                },
                greenHighlight: {
                    class: 'bg-green-400',
                    selectedClass: 'bg-green-100'
                },
                blueHighlight: {
                    class: 'bg-brand-500',
                    selectedClass: 'bg-blue-100'
                },
                purbleHighlight: {
                    class: 'bg-purple-400',
                    selectedClass: 'bg-purple-100'
                },
                note: {
                    class: 'bg-slate-400',
                    selectedClass: 'bg-slate-100'
                }
            },
            selectedFilters: []
        }
    },
    methods: {
        toggleSelectedFilter (color) {
            if (this.selectedFilters.includes(color)) {
                this.selectedFilters = this.selectedFilters.filter(f => f !== color)
                return
            }
            this.selectedFilters.push(color)
        },
        setHighlight (highlight) {
            this.modalData = null
            this.setPage(highlight.parent_page_id ?? highlight.page_id)
                .then(() => {
                    if (highlight.parent_page_id) {
                        const page = this.allPages.find(i => i.id === highlight.parent_page_id)
                        let regulation
                        let explanation
                        if (page.regulation && page.regulation.length && (regulation = page.regulation.find(r => r.link_id === highlight.context_id))) {
                            this.selectedStuffs('selectedRegulations', {
                                page: { id: highlight.parent_page_id },
                                idOfTheSelected: regulation.page_id,
                                show: true
                            })
                        } else if (page.explanation && page.explanation.length && (explanation = page.explanation.find(r => r.link_id === highlight.context_id))) {
                            this.selectedStuffs('selectedExplanations', {
                                page: { id: highlight.parent_page_id },
                                idOfTheSelected: explanation.page_id,
                                show: true
                            })
                        }
                    }
                    setTimeout(() => {
                        document.querySelector(`#page-${highlight.parent_page_id ?? highlight.page_id} [data-highlight-id="${highlight.id}"]`) && document.querySelector(`#page-${highlight.parent_page_id ?? highlight.page_id} [data-highlight-id="${highlight.id}"]`).scrollIntoView({ block: 'center', behavior: 'instant' })
                        this.isLoadingPages = false
                    }, 100)
                })
        }
    }
}
